export const FETCH_PROJECTTOPTENS_REQUEST = 'FETCH_PROJECTTOPTENS_REQUEST';
export const FETCH_PROJECTTOPTENS_SUCCESS = 'FETCH_PROJECTTOPTENS_SUCCESS';
export const FETCH_PROJECTTOPTENS_FAILURE = 'FETCH_PROJECTTOPTENS_FAILURE';
export const CREATE_PROJECTTOPTEN_REQUEST = 'CREATE_PROJECTTOPTEN_REQUEST';
export const CREATE_PROJECTTOPTEN_SUCCESS = 'CREATE_PROJECTTOPTEN_SUCCESS';
export const CREATE_PROJECTTOPTEN_FAILURE = 'CREATE_PROJECTTOPTEN_FAILURE';
export const CREATE_PROJECTTOPTENUPDATE_REQUEST = 'CREATE_PROJECTTOPTENUPDATE_REQUEST';
export const CREATE_PROJECTTOPTENUPDATE_SUCCESS = 'CREATE_PROJECTTOPTENUPDATE_REQUEST';
export const CREATE_PROJECTTOPTENUPDATE_FAILURE = 'CREATE_PROJECTTOPTENUPDATE_REQUEST';